import { render, staticRenderFns } from "./RegisterTestimonial.vue?vue&type=template&id=dc3e26b2&"
import script from "./RegisterTestimonial.vue?vue&type=script&lang=js&"
export * from "./RegisterTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports